export default '/build/afa1e2bd.jpg'